var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c("div", { class: _vm.slideInClass }, [
        _c("header", { staticClass: "titled" }, [
          _c("div", [
            _c("h2", [
              _vm._v(_vm._s(_vm.jobProfile.name || _vm.jobProfile.info))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "close-container" }, [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.onClose.apply(null, arguments)
                  }
                }
              },
              [_c("Icon", { attrs: { icon: "close" } })],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "main",
          { staticClass: "scrollbar-check" },
          [
            _c("Matching", {
              attrs: {
                "job-id": _vm.job.id,
                "job-profile-id": _vm.jobProfile.id
              },
              on: {
                loaded: function($event) {
                  _vm.loadedMatching = true
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.withActions && _vm.loadedMatching
          ? _c("footer", [
              _c(
                "div",
                { staticClass: "job-list-item-actions on-white-background" },
                [
                  !_vm.exclusion
                    ? [
                        _c("Favorite", {
                          attrs: {
                            "job-profile-id": _vm.jobProfile.id,
                            "job-id": _vm.job.id,
                            "initial-favored": _vm.favored,
                            type: "application"
                          },
                          on: { change: _vm.favoriteChanged }
                        }),
                        _vm._v(" "),
                        _c("Notice", {
                          attrs: {
                            "job-profile-id": _vm.jobProfile.id,
                            notice: _vm.notice,
                            type: "application"
                          },
                          on: { change: _vm.noticeChanged }
                        })
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c("Exclusion", {
                    attrs: {
                      "job-profile-item": _vm.jobProfile,
                      "job-id": _vm.job.id,
                      exclusion: _vm.exclusion
                    },
                    on: { change: _vm.exclusionChanged }
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "contact-button-container" },
                [
                  _vm.isPublished && !_vm.exclusion
                    ? _c("ContactJobProfile", {
                        attrs: {
                          "job-id": _vm.job.id,
                          "job-profile-id": _vm.jobProfile.id,
                          "job-profile-name": _vm.jobProfile.name,
                          "initial-in-contacting": _vm.hasOngoingConversation
                        },
                        on: { contacted: _vm.contactSuccessful }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }